var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [(_vm.displayMsg == 'success') ? _c('b-alert', {
    staticClass: "success-display-none",
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.displayMsg == 'error') ? _c('b-alert', {
    staticClass: "danger-display-none",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "32px",
      "border-color": "#799497 !important"
    },
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    ref: "mrch_id",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "id": "mrch_id",
      "options": _vm.listMerchantData1,
      "selected-option": _vm.item,
      "placeholder": _vm.$t('common.merchantPlaceholder')
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchant),
      callback: function($$v) {
        _vm.merchant = $$v
      },
      expression: "merchant"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('shipment.shipment')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "shipmentno",
      "placeholder": _vm.$t('shipment.shipmentPlaceholder')
    },
    model: {
      value: (_vm.shipmentno),
      callback: function($$v) {
        _vm.shipmentno = $$v
      },
      expression: "shipmentno"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.orderNumber')) + "  :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "orderno",
      "placeholder": _vm.$t('orders.orderNumberPlaceHolder')
    },
    model: {
      value: (_vm.orderno),
      callback: function($$v) {
        _vm.orderno = $$v
      },
      expression: "orderno"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.shipementStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchstatus),
      expression: "searchstatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('pickingReport.orderStatusPlaceholder')))]), _vm._v(" "), _vm._l((_vm.shipmentstatuslist), function(data) {
    return _c('option', {
      domProps: {
        "value": data.status_name
      }
    }, [_vm._v(_vm._s(data.status_name) + "\n                        ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.salesChannel')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchchannel),
      expression: "searchchannel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchchannel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchchannel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.salesChannelPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.channellist), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.saleschannel
      }
    }, [_vm._v("\n                          " + _vm._s(channel.saleschannel))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.fromDate')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.toDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "positionbtn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getshimentSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(_vm._s(_vm.$t('inwardList.reset')))])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('shipment.shipmentList')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 "
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('inwardList.table.count')) + " - " + _vm._s(_vm.totalRows))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listShipmentsData.length > 0 && !_vm.show) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "0px"
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listShipmentsData.length > 0 && !_vm.download) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-30px"
    },
    attrs: {
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.getShipmentList(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listShipmentsData.length > 0 && !_vm.download) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": "Download Excel",
      "header": _vm.dataFilter2,
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_vm._m(0), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.shipmentId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pincodemapping.status')) + " ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.orderNum')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('warehouseRacks.createdDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "9%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.salesChannel')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.totalSKU')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.totalQTY')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('shipment.reason')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('client.action')))])])])]), _vm._v(" "), _c('tbody', [(_vm.clientid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectClientFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('shipment.shipmentNotFound')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('shipment.shipmentNotFoundWithFilters')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listShipmentsData), function(data, index) {
    return [_c('tr', {
      staticClass: "text-center"
    }, [_c('td', {
      class: {
        opened: _vm.opened.includes(data._id)
      },
      staticStyle: {
        "padding": "5px",
        "color": "#0000e5",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showRow(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-down",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data._id))]), _vm._v(" "), (data.merchantname == null) ? _c('td') : _c('td', [_vm._v(_vm._s(data.merchantname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.order_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.channel_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalitem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalquantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.reason))]), _vm._v(" "), (data.status_name == 'Rejected' || data.status_name == 'To be Rejected') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("NA\n                  ")]) : _vm._e(), _vm._v(" "), (data.wms_status != 'cancelled' && data.status_name != 'Rejected' &&
      data.status_name != 'To be Rejected') ? _c('td', {
      staticClass: "text-center "
    }, [(_vm.cancelshipmentFlag == true) ? _c('span', [_c('i', {
      staticClass: "fa fa-times fa-lg mt-2 ",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "Cancel Shipment"
      },
      on: {
        "click": function($event) {
          _vm.ShipCancelShow = true;
          _vm.cancelshipdata = data;
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (data.wms_status == 'cancelled' && data.status_name != 'Rejected' && data.status_name != 'To be Rejected') ? _c('td', {
      staticClass: "text-center "
    }, [_vm._v(" " + _vm._s(_vm.$t('shipment.cancelled')))]) : _vm._e()]), _vm._v(" "), _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.contentVisible),
        expression: "data.contentVisible"
      }]
    }, [_c('td', {
      attrs: {
        "colspan": 13
      }
    }, [_c('fieldset', {
      staticStyle: {
        "padding": "10px 0 0 0"
      }
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('table', {
      staticClass: "table table-bordered mytable12",
      attrs: {
        "width": "100%"
      }
    }, [_c('thead', {
      staticClass: "theader"
    }, [_c('tr', {
      staticClass: "prod-list-table"
    }, [_c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('product.productId')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('product.productName')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('boxList.quantity')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('removeHold.productMrp')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.oneshipdetails), function(row) {
      return _c('tr', {
        staticClass: "prod-list-table"
      }, [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.productid))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.productname))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.qty))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.mrp))])])
    }))])])])])])])]
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    staticClass: "confirmation",
    attrs: {
      "size": "lm",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ShipCancelShow),
      callback: function($$v) {
        _vm.ShipCancelShow = $$v
      },
      expression: "ShipCancelShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('shipment.cancelShipment')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.ShipCancelShow = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('shipment.cancelShipmentPopup')) + "?\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-primary glass",
    staticStyle: {
      "width": "105px !important",
      "margin-left": "254px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelFullShipm()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('shipment.cancelOrder')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary glass",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ShipCancelShow = false;
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('shipment.backbtn')) + "\n            ")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.cancelshipModal),
      callback: function($$v) {
        _vm.cancelshipModal = $$v
      },
      expression: "cancelshipModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cancelshipModal),
      expression: "cancelshipModal"
    }],
    staticClass: "col-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "margin": "-21px !important"
    }
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('shipment.cancelShipmentProductList')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeshipModal
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "0.25rem !important"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h6', {
    staticClass: "header float-left",
    staticStyle: {
      "margin-left": "48px",
      "font-family": "Times New Roman, Times, serif",
      "font-size": "18px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('shipment.shipmentDetails')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h6', {
    staticClass: "header float-right",
    staticStyle: {
      "font-size": "15px",
      "font-family": "Times New Roman, Times, serif"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('orders.shipmentId')) + " - " + _vm._s(_vm.shipmentDetails._id))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered mytable12",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('orders.srNo')))])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.title')) + " ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('orders.productQuantity')) + " ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.select')))])])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cancelshipdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', [_vm._v(" " + _vm._s(data.productname) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', [_vm._v(_vm._s(data.qty) + " ")])]), _vm._v(" "), (data.status != 'cancelled') ? _c('td', {
      staticClass: "text-center"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedprod),
        expression: "selectedprod"
      }],
      attrs: {
        "type": "checkbox",
        "id": data.productid
      },
      domProps: {
        "value": data.itemid,
        "checked": Array.isArray(_vm.selectedprod) ? _vm._i(_vm.selectedprod, data.itemid) > -1 : (_vm.selectedprod)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedprod,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.itemid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedprod = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedprod = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedprod = $$c
          }
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (data.status == 'cancelled') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.$t('shipment.cancelled')))]) : _vm._e()])
  })), _vm._v(" "), _c('b-modal', {
    staticClass: "reModal",
    attrs: {
      "size": "ld",
      "title": "Alert Message"
    },
    model: {
      value: (_vm.comfirmModal),
      callback: function($$v) {
        _vm.comfirmModal = $$v
      },
      expression: "comfirmModal"
    }
  }, [_c('b-card', [_c('div', [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "0px 50px 0px 0px"
    }
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('shipment.confirmCancellation')) + "?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelConfim
    }
  }, [_vm._v(_vm._s(_vm.$t('common.confirm')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancelBtn')))])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row text-align: center"
  }, [(_vm.errmessage != "" && _vm.selectedprod.length == 0) ? _c('label', {
    staticStyle: {
      "float": "middle"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errmessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row float-right"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.cancelprodlist()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.confirm')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.closeshipModal()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')) + " ")])])])])], 1)])], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b')])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4acf6679", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4acf6679","hasScoped":true}!./src/views/components/shipment/shipment.component.html
// module id = 1730
// module chunks = 0